import Vue from "vue";
import recom from "../layout/components/recom.vue";
import store from "@/store/index.js";
import { assembleMenuTree } from "./menuRuntime.core.js";

// componentRef 字符串 -> 真实组件(Layout=recom;否则异步 require)
export function toRouterConfig(menuTree) {
  return (menuTree || []).map((node) => {
    const obj = { path: node.path, name: node.name, meta: { ...node.meta } };
    if (node.componentRef === "Layout") {
      Vue.set(obj, "component", recom);
    } else {
      Vue.set(obj, "component", (resolve) => require([`@/views/${node.componentRef}`], resolve));
    }
    if (node.children && node.children.length) {
      obj.children = toRouterConfig(node.children);
    }
    return obj;
  });
}

// 兼容导出:旧调用方(含死文件)仍可用。返回 vue-router 配置;并写 routestext + 置 routeadds=1。
export function changeroute(routers) {
  const { tree } = assembleMenuTree(routers, 1);
  const routerTree = toRouterConfig(tree);
  sessionStorage.setItem("routestext", JSON.stringify(tree));
  store.commit("routestatus", 1);
  return routerTree;
}
